var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPteIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.25 3.75293V14H0.875V0H8.49707L12.25 3.75293ZM8.75 3.5H10.7529L8.75 1.49707V3.5ZM11.375 4.375H7.875V0.875H1.75V13.125H11.375V4.375ZM2.625 6.125H5.25V8.75H2.625V6.125ZM3.5 7.875H4.375V7H3.5V7.875ZM2.625 2.625H5.25V5.25H2.625V2.625ZM3.5 4.375H4.375V3.5H3.5V4.375ZM6.125 7H10.5V7.875H6.125V7ZM2.625 9.625H5.25V12.25H2.625V9.625ZM3.5 11.375H4.375V10.5H3.5V11.375ZM6.125 10.5H10.5V11.375H6.125V10.5Z",
    fill: "#323130"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPteIcon);
export default __webpack_public_path__ + "static/media/pteIcon.8869236467dac358b73d2b6f8cf73ae1.svg";
export { ForwardRef as ReactComponent };